<template>
  <van-tabbar v-model="active" class="tabbar_top"> 
    <van-tabbar-item
      v-if="IsProduct"
      icon="apps-o"
      @click="Skip('storeorder')"
      name="storeorder"
      >  {{ tools.GetLanguageValue("public.app.菜单") }}</van-tabbar-item
    >
    <van-tabbar-item
      v-if="IsTaoCanFixed"
      name="storeCollection"
      icon="orders-o"
      @click="Skip('storeCollectionFixed')"
      > {{ tools.GetLanguageValue("public.app.套餐") }}</van-tabbar-item
    >
    <van-tabbar-item
      v-if="IsTaoCan"
      name="storeCollection"
      icon="orders-o"
      @click="Skip('storeCollection')"
      > {{ tools.GetLanguageValue("public.app.套餐") }}</van-tabbar-item
    >
    <van-tabbar-item
      name="storeshoppingcart"
      v-if="!tableCart"
      icon="shopping-cart-o"
      @click="Skip('storeshoppingcart')"
      > {{ tools.GetLanguageValue("public.app.购物车") }}</van-tabbar-item
    >
 
  </van-tabbar>
</template> 
<script >
import axios from "../../commons/AxiosMethod.js";
import commons from "../../commons/commons.js";
import tools from "../../commons/tools.js";

//product_categorys
export default {
  data() {
    return {
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,
      UserIsAuthenticated: true,

      tools: tools,
      IsDefault: false,
      IsProduct: false,
      IsTaoCan: false,
      IsTaoCanFixed: false,
      IsTaoCanQianTai: false,
      tableCart:false,
    };
  },
  props: {
    active: "",
  },
  name: "App",
  mounted() {
    this.GetHomeType();
  },
  components: {},
  methods: {
    GetHomeType() {
      var TableId = localStorage.getItem("Cache-TableId");
      axios.apiMethod(
        "/Store/StoreOrder/GetHomeType",
        "get",
        { tableId: TableId },
        (result) => {
          this.HomeTypes = JSON.parse(result.Data.Value).HomeTypes;
          if (this.HomeTypes.length == 0) {
            this.HomeTypes.push("Default");
          }
          if (this.HomeTypes.indexOf("FixedTaoCan") > -1) {
            this.IsTaoCanFixed = true; 
            return;
          }

          if (this.HomeTypes.indexOf("Default") > -1) {
            this.IsProduct = true;
            this.IsTaoCan = true;
            return;
          }
          if (this.HomeTypes.indexOf("Product") > -1) {
            this.IsProduct = true;
          }
          if (this.HomeTypes.indexOf("TaoCan") > -1) {
            this.IsTaoCan = true;
            return;
          }
 
          if (this.HomeTypes.indexOf("TaoCanQianTai") > -1) {
         
            this.IsTaoCanQianTai = true;  
            return;
          } 
        }
      );
    },

    Skip(item) {
      var TableId = localStorage.getItem("Cache-TableId");
      this.$router.push({
        path: item,
        query: {
          tableId: TableId,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.tabbar_top {
  border-top: 1px solid #eee;
  width: 100%;
}
</style>
